import { LAYOUTS, } from "@voltmoney/types";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconAlignmentTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { goBack, DisbursalVerifyAction, CreateDisbursementRequest, } from "./actions";
import SharedPropsService from "../../../SharedPropsService";
import { heightMap } from "../../../configs/height";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
export const template = (mobileNumber, noOfOtpDigits) => ({
    layout: {
        id: ROUTE.EMAIL_VERIFY_OTP,
        type: LAYOUTS.MODAL,
        style: {
            height: heightMap[ROUTE.WITHDRAWAL_OTP],
        },
        widgets: [
            { id: "headerSpace", type: WIDGET.SPACE },
            {
                id: "headerStack",
                type: WIDGET.STACK,
            },
            { id: "titleSpace", type: WIDGET.SPACE },
            { id: "emailSubtitle", type: WIDGET.EMAIL_SUBTITLE },
            { id: "subTitleSpace", type: WIDGET.SPACE },
            { id: "otpModalScreen", type: WIDGET.OTP_MODAL_SCREEN },
            // { id: "inputSpace", type: WIDGET.SPACE },
        ],
    },
    datastore: {
        otpModalScreen: {
            id: 'tf_verifyEmailScreen_otp',
            type: InputTypeToken.OTP,
            state: InputStateToken.DEFAULT,
            charLimit: noOfOtpDigits,
            keyboardType: KeyboardTypeToken.numberPad,
            action: {
                type: ACTION.WITHDRAWAL_OTP,
                payload: {
                    value: "",
                    emailId: mobileNumber,
                    noOfOtpDigits: noOfOtpDigits
                },
                routeId: ROUTE.EMAIL_VERIFY_OTP,
            },
            otpAction: {
                type: ACTION.RESEND_WITHDRAWAL_OTP,
                payload: {
                    emailId: mobileNumber
                },
                routeId: ROUTE.EMAIL_VERIFY_OTP,
            },
        },
        headerStack: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: "title", type: WIDGET.TEXT },
                { id: "leadIcon", type: WIDGET.BUTTON },
            ],
        },
        title: {
            label: `Enter ${noOfOtpDigits}-digit OTP`,
            fontSize: FontSizeTokens.XL,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: "600",
            lineHeight: 28,
        },
        leadIcon: {
            id: 'txt_verifyEmailScreen_cancel',
            label: "",
            type: ButtonTypeTokens.SmallGhost,
            width: ButtonWidthTypeToken.CONTENT,
            stack: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
            },
            labelColor: ColorTokens.Grey_Night,
            icon: {
                name: IconTokens.Cross,
                align: IconAlignmentTokens.right,
                size: IconSizeTokens.XXL
            },
            action: {
                type: ACTION.GO_BACK,
                payload: {},
                routeId: ROUTE.EMAIL_VERIFY_OTP,
            },
        },
        titleSpace: { size: SizeTypeTokens.XL },
        headerSpace: { size: SizeTypeTokens.MD },
        subTitle: {
            label: "OTP sent to",
            subLabel: mobileNumber,
            color: ColorTokens.Grey_Charcoal,
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
        },
        emailSubtitle: {
            label: "OTP sent to",
            subLabel: mobileNumber,
            iconUrl: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icon_holder.png",
            iconName: IconTokens.EMAIL_VERIFY_MAIL_ICON
        },
        subTitleSpace: { size: SizeTypeTokens.XXXL },
        input: {
            id: 'tf_verifyEmailScreen_otp',
            type: InputTypeToken.OTP,
            state: InputStateToken.DEFAULT,
            charLimit: noOfOtpDigits,
            keyboardType: KeyboardTypeToken.numberPad,
            action: {
                type: ACTION.WITHDRAWAL_OTP,
                payload: {
                    value: "",
                    emailId: mobileNumber,
                    noOfOtpDigits: noOfOtpDigits
                },
                routeId: ROUTE.EMAIL_VERIFY_OTP,
            },
            otpAction: {
                type: ACTION.RESEND_WITHDRAWAL_OTP,
                payload: {
                    emailId: mobileNumber
                },
                routeId: ROUTE.EMAIL_VERIFY_OTP,
            },
        },
        inputSpace: { size: SizeTypeTokens.XXXXL },
        message: {
            label: "Resend OTP in 14 secs",
            fontSize: FontSizeTokens.XS,
            color: ColorTokens.Grey_Charcoal,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
        },
    },
});
export const emailVerifyOtp = {
    onLoad: async (_, { emailId }) => {
        const email = emailId;
        const user = await SharedPropsService.getUser();
        const response = await _.network.post(`${api.triggerEmailOtp}`, {
            borrowerAccountId: (await SharedPropsService.getUser())
                .linkedBorrowerAccounts[0].accountId,
            emailId: emailId
        }, { headers: await getAppHeader() });
        if (response?.data?.noOfDigits) {
            await SharedPropsService.setNumberOfOtpDigits(response?.data?.noOfDigits);
        }
        const numberOfOtp = response?.data?.noOfDigits ? response?.data?.noOfDigits : await SharedPropsService.getNumberOfOtpDigits();
        return Promise.resolve(template(email, parseInt(numberOfOtp)));
    },
    actions: {
        [ACTION.WITHDRAWAL_OTP]: DisbursalVerifyAction,
        [ACTION.RESEND_WITHDRAWAL_OTP]: CreateDisbursementRequest,
        [ACTION.GO_BACK]: goBack,
    },
    clearPrevious: true,
};
